var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazyImage",class:{'is-loaded': _vm.loaded}},[_c('div',{staticClass:"lazyImage-bg"}),_c('img',{ref:"image",staticClass:"lazyImage-img",attrs:{"src":_vm.srcset}})])}
var staticRenderFns = []

export { render, staticRenderFns }